import { CouponValidateResponse } from '../types/order';

export const CONTRACT_LABELS: Record<string, string> = {
  no_contract: 'No contract',
  '12_month': '12-month contract',
  '24_month': '24-month contract',
};

const ok = (allowed: string[] | null | undefined, contract: string) =>
  !allowed || allowed.length === 0 || allowed.includes(contract || 'no_contract');

export function contractList(types: string[] | null | undefined): string {
  return (types || []).map((t) => CONTRACT_LABELS[t] || t).join(' or ');
}

/** What a validated coupon gives for the contract currently selected. */
export function couponStatus(coupon: CouponValidateResponse | null | undefined, contract: string) {
  if (!coupon) return null;
  const hasDiscount = coupon.discount_amount != null;
  const discountActive = hasDiscount && ok(coupon.discount_contract_types, contract);
  const hasBonus = !!coupon.bonus_title;
  const bonusActive = hasBonus && ok(coupon.bonus_contract_types, contract);
  return {
    hasDiscount,
    discountActive,
    discountNeeds: hasDiscount && !discountActive ? contractList(coupon.discount_contract_types) : null,
    hasBonus,
    bonusActive,
    bonusNeeds: hasBonus && !bonusActive ? contractList(coupon.bonus_contract_types) : null,
  };
}
